module.exports = __webpack_public_path__ + "img/step-three-img.dc41c72.svg";